import styled, {keyframes} from 'styled-components';
import media from 'styled-media-query';
import Button from 'components/Button';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

export const Container = styled.div`
  margin:30px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
`

export const ContentInput = styled.div`
  width: 60%;
  margin-right: 3%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const WrapperList = styled.div`
  margin-top: 30px;
`

export const NotFound = styled.span`
  font-size: 3rem;
  color: grey;
  text-align: center;
  margin-top: 30%;
`